import { createFileRoute } from '@tanstack/react-router'
import { ArchiveList } from '@/features/archive/ArchiveList'
import { PageHeading } from '@/components/PageHeading'

export const Route = createFileRoute('/archive')({
  component: ArchivePage,
})

function ArchivePage() {
  return (
    <div className="py-6 sm:py-8">
      <PageHeading title="Archive" meta="Everything put away" />
      <div className="mt-6">
        <ArchiveList />
      </div>
    </div>
  )
}
